"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}

exports.isObject = isObject;
exports.noDefaultsSymbol = Symbol("@@FLAG_NO_DEFAULTS");